<script>
    import { closeModal } from 'svelte-modals';
    import { Link } from 'svelte-navigator';
    import { getLanguage, getUrlParam } from '../../helpers/url';

    // provided by <Modals />
    export let isOpen;

    export let request;

    // import { useNavigate } from 'svelte-navigator';

    import { push } from 'svelte-spa-router';

    // const navigate = useNavigate();

    function goToForm() {
        localStorage.setItem('onrequest', JSON.stringify(request));
        closeModal();
        window.location.href = `?lang=${getLanguage()}&page=form&id=${getUrlParam(
            'id'
        )}`;
    }
</script>

{#if isOpen}
    <div role="dialog" class="modal">
        <div class="contents">
            <div class="actions">
                <div class="delete-button" on:click={closeModal}>
                    <i class="fas fa-times" />
                </div>
            </div>
            <div>
                <h2>Make a booking request</h2>
                <p>
                    Please note, this booking needs to be confirmed with the
                    operator.
                </p>
                <p>
                    You'll receive an email within 24 hours to confirm if your
                    booking has been accepted and if so you can pay securely
                    online
                </p>
            </div>

            <button on:click={goToForm} class="first-button">Confirm</button>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        /* allow click-through to backdrop */
        pointer-events: none;
    }

    .contents {
        min-width: 240px;
        max-width: 800px;
        border-radius: 6px;
        padding: 16px;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        pointer-events: auto;
    }

    .actions {
        margin: 10px;
        display: flex;
        justify-content: flex-end;
    }
    .actions i {
        font-size: 15px;
    }
</style>
